import { defineMessages } from 'react-intl'

export default defineMessages({
  back: {
    id: 'Back',
    defaultMessage: 'Back'
  },
  pageTitle: {
    id: 'OrganizationUserProvisioningPage.Title',
    defaultMessage: 'User Provisioning'
  }
})
